
export  const listNiveau = [
    {id:1,intitule:"Novice"},
    {id:2,intitule:"Débutant"},
    {id:3,intitule:"Intermédiaire"},
    {id:4,intitule:"Confirmé"}
];
export  const listFidelite = [
    {id:1,intitule:"Première fois"},
    {id:2,intitule:"déjà venu"},
    {id:3,intitule:"habitué"},
    {id:4,intitule:"Wally dépendant"}
];